module.exports = __webpack_public_path__ + "img/Options.47ee3935.svg";